import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {User} from '../users';
import {Employee} from '../employees';
import _ from 'lodash';

const RETROACTIVE_UPDATE_TYPES = [
  'retroactive_pay_rates',
  'retroactive_synced_hours'
];

class NmbrUpdate extends DomainObject {
  employee;
  fieldUpdates;
  createdByUser;
  createdAt;
  effectiveDate;
  eventType;

  _relations = {
    eventType: oneOf([
      'employee_added',
      'employee_updated',
      'employment_record_created',
      'employment_record_updated',
      'employment_record_destroyed',
      'on_leave_record_created',
      'on_leave_record_updated',
      'on_leave_record_destroyed',
      'termination_record_created',
      'termination_record_destroyed',
      'reactivation_record_created',
      'reactivation_record_updated',
      'reactivation_record_destroyed',
      'return_from_leave_record_created',
      'return_from_leave_record_updated',
      'return_from_leave_record_destroyed',
      'tax_form_completed',
      'employee_removed',
      'time_off_request_approved',
      'time_off_request_updated',
      'time_off_request_destroyed',
      'timesheet_approved',
      'added_to_time_tracking',
      'removed_from_time_tracking',
      'switched_to_hourly',
      'switched_to_salary',
      'expense_request_approved',
      'expense_request_destroyed'
    ]),
    _dates: ['effectiveDate', 'createdAt'],
    createdByUser: User,
    employee: Employee
  };

  constructor(other) {
    super();

    makeObservable(this, {
      employee: observable,
      fieldUpdates: observable,
      createdByUser: observable,
      createdAt: observable,
      effectiveDate: observable,
      eventType: observable,
      retroactiveFieldUpdates: computed,
      hasRetroactiveFieldUpdates: computed,
      hasNonRetroactiveFieldUpdates: computed
    });

    this.merge(other);
  }

  get retroactiveFieldUpdates() {
    return this.fieldUpdates.
      map((fieldUpdate, index) => ({...fieldUpdate, index})).
      filter(fieldUpdate => RETROACTIVE_UPDATE_TYPES.includes(fieldUpdate.updateType));
  }

  get hasNonRetroactiveFieldUpdates() {
    return this.fieldUpdates.some(fieldUpdate => !RETROACTIVE_UPDATE_TYPES.includes(fieldUpdate.updateType));
  }

  get hasRetroactiveFieldUpdates() {
    return !_.isEmpty(this.retroactiveFieldUpdates);
  }

  hasFieldUpdate(updateType) {
    return this.fieldUpdatesForType(updateType).length > 0;
  }

  fieldUpdatesForType(updateType) {
    return _.filter(this.fieldUpdates, {updateType});
  }
}

export default NmbrUpdate;
